module.exports = {
  PM_COMM_TYPE_INV_AUTH: `inv-auth`
}
